import { FacultyAction, FacultyActionType } from '../actions/FacultyActions';
import { Faculty } from '../types';

const facultyReducer = (state: Array<Faculty> = [], action: FacultyAction) => {
    switch (action.type) {
        case FacultyActionType.GET_ALL_FACULTIES:
        case FacultyActionType.GET_ALL_ADMIN_FACULTIES:
            return action.payload;
        case FacultyActionType.CREATE_FACULTY:
            return [...state, action.payload];
        case FacultyActionType.GET_FACULTY:
        case FacultyActionType.DELETE_FACULTIES:
        case FacultyActionType.MERGE_FACULTIES:
        case FacultyActionType.UPDATE_FACULTY:
            return state.map((faculty: Faculty) => {
                const newFaculty = action.payload as Faculty;
                if (faculty._id === newFaculty._id) {
                    return newFaculty;
                } else {
                    return faculty;
                }
            });
        default:
            return state;
    }
};

export default facultyReducer;
